import { ServiceData } from '../service';
import db from '../index';
import { entityServiceFactory } from '../entityServiceFactory';

export interface InspectionsServiceData extends ServiceData {}
const { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain } =
  entityServiceFactory<InspectionsServiceData>(db, 'inspectionsService');

export { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain };
